import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Card, Typography, message, Layout } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { Link, useSearchParams } from 'react-router-dom';
import useAuthApis from '../apis/useAuthApis';

const { Title } = Typography;
const { Content } = Layout;

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  console.log("Token from URL:", token);
  const { resetPasswordApi } = useAuthApis();

  useEffect(() => {
    if (!token) {
      message.error('Invalid or missing token.');
      console.error('Token is missing or invalid.');
    }
  }, [searchParams]);
  
  const onFinish = async (values) => {
    setLoading(true);
    const { password, confirmPassword } = values;
    if (password !== confirmPassword) {
      message.error('Passwords do not match!');
      setLoading(false);
      return;
    }
    
    // Ensure the token is included in the API call
    const res = await resetPasswordApi({ ...values, token: token }); // Ensure token is included
    if (res.error) {
      message.error(res.message || 'Invalid email');
      setLoading(false);
    } else {
      message.success('Password reset successfully');
      form.resetFields();
      setLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Content style={{ 
        width: '100%', 
        maxWidth: '400px', 
        margin: '0 auto', 
        marginTop: '10vh' 
      }}>
        <Card style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Seal_of_Uttar_Pradesh.svg/478px-Seal_of_Uttar_Pradesh.svg.png"
              alt="UP Logo"
              style={{
                height: '80px',
                marginBottom: '20px'
              }}
            />
            <Title level={2} style={{ margin: 0 }}>
            UP Municipal Admin
            </Title>
            <Title level={4} style={{ margin: 0, fontWeight: 'normal', color: 'rgba(0, 0, 0, 0.45)' }}>
            Forgot Password
            </Title>
          </div>

          <Form
            form={form}
            name="reset-password"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Please input your password',
                },              
                {
                  pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                  message: 'Password must include uppercase, lowercase, number, and special character.',
                },
              ]}
            >
              <Input.Password 
                prefix={<LockOutlined />} 
                placeholder="Password" 
                size="large" 
                maxLength={50}
              />
            </Form.Item>

            <Form.Item
              name="confirmPassword"
              rules={[
                {
                  required: true,
                  message: 'Please confirm your password',
                },              
                {
                  pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                  message: 'Password must include uppercase, lowercase, number, and special character.',
                },
              ]}
            >
              <Input.Password 
                prefix={<LockOutlined />} 
                placeholder="Confirm Password" 
                size="large" 
                maxLength={50}
              />
            </Form.Item>

            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                block 
                size="large"
                loading={loading}
              >
                Reset Password
              </Button>
            </Form.Item>
            <div style={{ textAlign: 'center', marginTop: '10px' }}>
              <Link to="/" style={{ marginRight: '10px' }}>
                Back to Login
              </Link>
            </div>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
};

export default ResetPassword; 